import React from "react";
import QuoteRequestModalHomeLibrary from "./quote-request-modal-home-library";

export default class KeygroupsImages extends React.Component  
{
    constructor(props)    
    {
        super(props);

        if(!this.props.hide && this.props.code !== undefined)
        {
            this.requestImageFile = require.context('../images/keygroups', true, /.jpg$/);
            this.imageContainerClass = "card"
            this.code = this.props.code;
            this.alone = ' alone';
            switch(this.code)
            {
                case 'pool-removal':
                    this.services =
                    [
                        {
                            title: 'Popular Swimming Pool Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Above Ground Pool Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Above Ground Pool Removal',
                                        path: './Scroll-Image---Above-Ground-Pool-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Inground Pool Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Inground Pool Removal',
                                        path: './Scroll-Image---Inground-Pool-Removal.jpg'
                                    }
                                }   
                            ]
                        }
                    ]
                    break

                case 'oil-tank-removal':
                    this.services =
                    [
                        {
                            title: 'Popular Tank Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Oil Tank Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Oil Tank Removal',
                                        path: './Scroll-Image---Oil-Tank-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Propane Tank Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Propane Tank Removal',
                                        path: './Scroll-Image---Propane-Tank-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Septic Tank Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Septic Tank Removal',
                                        path: './Scroll-Image---Septic-Tank-Removal.jpg'
                                    }
                                }    
                            ]
                        }
                    ]
                    break

                case 'barn-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Barn Demolition Projects',
                            cards:
                            [
                                {
                                    title: 'Barn Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Barn Demolition',
                                        path: './Scroll-Image---Barn-Demolition.jpg'
                                    }
                                }  
                            ]
                        }
                    ]
                    break
                
                case 'chimney-removal':
                    this.services =
                    [
                        {
                            title: 'Popular Chimney Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Chimney Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Chimney Removal',
                                        path: './Scroll-Image---Chimney-Removal.jpg'
                                    }
                                }  
                            ]
                        }
                    ]
                    break

                case 'commercial-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Commercial Demolition Projects',
                            cards:
                            [
                                {
                                    title: 'Commercial Building Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Commercial Building Demolition',
                                        path: './Scroll-Image---Commercial-Demolition.jpg'
                                    }
                                }  
                            ]
                        }
                    ]
                    break

                case 'concrete-removal':                    
                    this.services =
                    [
                        {
                            title: 'Popular Concrete Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Brick Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Brick Removal',
                                        path: './Scroll-Image---Brick-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Asphalt Driveway Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Asphalt Driveway Removal',
                                        path: './Scroll-Image---Asphalt-Driveway-Removal.jpg'
                                    }
                                },                                
                                {
                                    title: 'Asphalt Parking Lot Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Asphalt Parking Lot Removal',
                                        path: './Scroll-Image---Asphalt-Parking-Lot-Removal.jpg'
                                    }
                                },                                
                                {
                                    title: 'Concrete Driveway Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Driveway Removal',
                                        path: './Scroll-Image---Concrete-Driveway-Removal.jpg'
                                    }
                                },                                
                                {
                                    title: 'Concrete Foundation Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Foundation Removal',
                                        path: './Scroll-Image---Concrete-Foundation-Removal.jpg'
                                    }
                                },                                
                                {
                                    title: 'Concrete Parking Lot Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Parking Lot Removal',
                                        path: './Scroll-Image---Concrete-Parking-Lot-Removal.jpg'
                                    }
                                },                                
                                {
                                    title: 'Concrete Patio Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Patio Removal',
                                        path: './Scroll-Image---Concrete-Patio-Removal.jpg'
                                    }
                                },                                
                                {
                                    title: 'Concrete Sidewalk Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Sidewalk Removal',
                                        path: './Scroll-Image---Concrete-Sidewalk-Removal.jpg'
                                    }
                                },                                
                                {
                                    title: 'Other Asphalt/Concrete Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Other Asphalt/Concrete Removal',
                                        path: './Scroll-Image---Other-Concrete-Asphalt-Removal.jpg'
                                    }
                                }                                                                    
                            ]
                        }
                    ]
                    break

                case 'residential-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Residential Demolitions Projects',
                            cards:
                            [
                                {
                                    title: 'Deck Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Deck Removal',
                                        path: './Scroll-Image---Deck-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Fence Removal',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Fence Removal',
                                        path: './fence-_emoval.jpg'
                                    }
                                },
                                {
                                    title: 'Shed Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Shed Demolition',
                                        path: './Scroll-Image---Shed-Demolition.jpg'
                                    }
                                }   
                            ]
                        }
                    ]
                    break

                case 'house-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Commercial Demolition Projects',
                            cards:
                            [
                                {
                                    title: 'Garage Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Garage Demolition',
                                        path: './Scroll-Image---Garage-Demolition.jpg'
                                    }
                                },
                                {
                                    title: 'House Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'House Demolition',
                                        path: './Scroll-Image---House-Demolition.jpg'
                                    }
                                }    
                            ]
                        }
                    ]
                    break

                case 'interior-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Interior Demolition Projects',
                            cards:
                            [
                                {
                                    title: 'Commercial Interior Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Commercial Interior Demolition',
                                        path: './Scroll-Image---Commercial Interior Demolition.jpg'
                                    }
                                },
                                {
                                    title: 'Residential Interior Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Residential Interior Demolition',
                                        path: './Scroll-Image---Residential-Interior-Demolition.jpg'
                                    }
                                }    
                            ]
                        }
                    ]
                    break

                case 'mobile-home-demolition':
                    this.services =
                    [
                        {
                            title: 'Popular Mobile Home Removal Projects',
                            cards:
                            [
                                {
                                    title: 'Mobile Home Demolition',
                                    code: this.code,
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Mobile Home Demolition',
                                        path: './Scroll-Image---Mobile-Home-Demolition.jpg'
                                    }
                                }    
                            ]
                        }
                    ]
                    break
                
                default:    
                    this.alone = '';                
                    this.services = 
                    [
                        {
                            title: 'Complete Structural Demolition',
                            cards:[
                                {
                                    title: 'House Demolition',
                                    code: 'house-demolition',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'House Demolition',
                                        path: './Scroll-Image---House-Demolition.jpg'
                                    }
                                },
                                {
                                    title: 'Commercial Building Demolition',
                                    code: 'commercial-demolition',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Commercial Building Demolition',
                                        path: './Scroll-Image---Commercial-Demolition.jpg'
                                    }
                                },
                                {
                                    title: 'Mobile Home Demolition',
                                    code: 'mobile-home-demolition',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Mobile Home Demolition',
                                        path: './Scroll-Image---Mobile-Home-Demolition.jpg'
                                    }
                                },
                                {
                                    title: 'Garage Demolition',
                                    code: 'house-demolition',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Garage Demolition',
                                        path: './Scroll-Image---Garage-Demolition.jpg'
                                    }
                                },
                                {
                                    title: 'Barn Demolition',
                                    code: 'barn-demolition',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Barn Demolition',
                                        path: './Scroll-Image---Barn-Demolition.jpg'
                                    }
                                }                    
                            ]
                        },
                        {
                            title: 'Swimming Pool & Concrete Removal',
                            cards:[
                                {
                                    title: 'Inground Pool Removal',
                                    code: 'pool-removal',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Inground Pool Removal',
                                        path: './Scroll-Image---Inground-Pool-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Concrete Driveway Removal',
                                    code: 'concrete-removal',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Driveway Removal',
                                        path: './Scroll-Image---Concrete-Driveway-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Asphalt Parking Lot Removal',
                                    code: 'concrete-removal',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Asphalt Parking Lot Removal',
                                        path: './Scroll-Image---Asphalt-Parking-Lot-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Above Ground Pool Removal',
                                    code: 'pool-removal',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Above Ground Pool Removal',
                                        path: './Scroll-Image---Above-Ground-Pool-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Concrete Sidewalk Removal',
                                    code: 'concrete-removal',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Concrete Sidewalk Removal',
                                        path: './Scroll-Image---Concrete-Sidewalk-Removal.jpg'
                                    }
                                }                    
                            ]
                        },
                        {
                            title: 'Interior & Selective Demolition',
                            cards:[
                                {
                                    title: 'Commercial Interior Demolition',
                                    code: 'interior-demolition',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Commercial Interior Demolition',
                                        path: './Scroll-Image---Commercial-Interior-Demolition.jpg'
                                    }
                                },
                                {
                                    title: 'Residential Interior Demolition',
                                    code: 'interior-demolition',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Residential Interior Demolition',
                                        path: './Scroll-Image---Residential-Interior-Demolition.jpg'
                                    }
                                },
                                {
                                    title: 'Chimney Removal',
                                    code: 'chimney-removal',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Chimney Removal',
                                        path: './Scroll-Image---Chimney-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Oil Tank Removal',
                                    code: 'oil-tank-removal',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Oil Tank Removal',
                                        path: './Scroll-Image---Oil-Tank-Removal.jpg'
                                    }
                                },
                                {
                                    title: 'Deck Removal',
                                    code: 'residential-demolition',
                                    ondeffCode: 'demolitionQuoteRequest',
                                    image:
                                    {
                                        alt: 'Deck Removal',
                                        path: './Scroll-Image---Deck-Removal.jpg'
                                    }
                                }                    
                            ]
                        }                
                    ]
                    break
            }         
        }
    }   
    
    render()
    {
        if(this.props.hide)
        {
            return( <></> )
        }

        return (
            <div className={"container-fluid keygroups-images"+this.alone}>      
                <div className="container">          
                    <div className="row">
                    {
                            this.services && this.services.map(service =>
                            {                                                 
                                return(
                                    <div className="col-12">
                                        <h3>{service.title}</h3>
                                            <div className="cards">
                                            {
                                                service.cards.map((card, index) =>
                                                {
                                                    return(
                                                    <QuoteRequestModalHomeLibrary
                                                        service={card}
                                                        startVisible={false}
                                                        requestImageFile={this.requestImageFile}
                                                        imageContainerClass={this.imageContainerClass}>
                                                        </QuoteRequestModalHomeLibrary>) 
                                                })
                                            } 
                                        </div>                                   
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
};